// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSocialWechat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.114 11.257c-1.325 1.395-1.93 3.105-1.764 5.224l-1.048-.147c-.34-.046-.67-.089-1.003-.119-.23-.021-.502.009-.697.128-.46.283-.908.591-1.394.926a95.31 95.31 0 0 1-.603.414l.215-1.114c.024-.117.049-.232.075-.345l.086-.338c.113-.409.06-.637-.287-.903-2.228-1.709-3.168-4.266-2.465-6.9.65-2.435 2.248-3.912 4.418-4.683a7.058 7.058 0 0 1 8.093 2.576 6.322 6.322 0 0 1 1.155 3.183c-1.856.105-3.47.717-4.781 2.098zm9.249 8.266c-.573.552-.779 1.006-.411 1.733.045.09.064.198.083.31.01.054.019.109.031.164-.181-.088-.358-.19-.532-.29-.391-.223-.772-.441-1.169-.486-.336-.038-.682.07-1.031.178a4.038 4.038 0 0 1-.74.181c-1.823.203-3.456-.349-4.802-1.701-2.561-2.572-2.195-6.517.767-8.625 2.633-1.873 6.495-1.249 8.352 1.351 1.57 2.2 1.44 5.098-.374 7.01zm-6.984-6.333c-.387-.002-.713.36-.7.779.014.4.324.723.695.724.375 0 .683-.318.697-.72.015-.424-.3-.78-.692-.783zm4.3 1.498c.376.001.673-.308.686-.713.015-.427-.29-.78-.677-.783-.363-.003-.671.32-.686.719-.016.426.29.776.677.777zm-5.87-7.28c-.458.01-.845.433-.837.917.008.5.388.893.859.887.472-.006.83-.403.826-.914-.004-.503-.382-.899-.848-.89zm-5.333 1.8c.466.012.858-.376.875-.87.017-.48-.367-.915-.824-.93-.467-.014-.851.374-.865.874-.014.506.343.913.814.926z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialWechat;
